import { visserApi } from './visserApi';
const getAllInvoice = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`Invoice/GetAll?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getAllInvoiceStatus = async () => {
    return await visserApi.get('Invoice/GetAllInvoiceStatus');
};
const getWorkOrdersListWithClientAsync = async (workOrderNumber) => {
    return await visserApi.get(`Quotation/GetWorkOrdersListWithClient/${workOrderNumber}`);
};
const getInvoiceById = (invoiceId) => {
    return visserApi.get(`Invoice/GetById/${invoiceId}`);
};
const getIncrementedInvoiceNumber = async () => {
    return visserApi.get('Invoice/GetIncrementedInvoiceNumber');
};
const createInvoice = async (createdInvoice) => {
    return visserApi.post('Invoice/Create', createdInvoice);
};
const updateInvoice = async (updatedInvoide) => {
    return visserApi.post('Invoice/Update', updatedInvoide);
};
const createInvoiceAmount = async (createInvoiceAmount) => {
    return await visserApi.post('Invoice/CreateInvoiceAmount', createInvoiceAmount);
};
const getAllInvoiceAmounts = async (invoiceId) => {
    return await visserApi.get(`Invoice/GetAllInvoiceAmounts/${invoiceId}`);
};
const updateInvoiceAmount = async (updateInvoiceAmount) => {
    return await visserApi.put(`Invoice/UpdateInvoiceAmount`, updateInvoiceAmount);
};
const getInvoiceAmountById = async (id) => {
    return await visserApi.get(`Invoice/GetInvoiceAmountById/${id}`);
};
const deleteInvoiceAmount = async (id) => {
    return await visserApi.delete(`Invoice/DeleteInvoiceAmount/${id}`);
};
const deleteInvoiceById = async (id) => {
    return await visserApi.delete(`Invoice/Delete/${id}`);
};
const updateInvoiceAmountPosition = async (updateInvoiceAmountPosition) => {
    return await visserApi.put(`Invoice/UpdateInvoiceAmountPosition`, updateInvoiceAmountPosition);
};
const updateBulkInvoiceAmount = async (updateInvoiceAmountPosition) => {
    return await visserApi.put(`Invoice/UpdateBulkInvoiceAmount`, updateInvoiceAmountPosition);
};
const generateCostEstimatePdf = async (costEstimatePdfData) => {
    const response = await visserApi.post(`Invoice/GenerateCostEstimatePdf`, costEstimatePdfData);
    return response.data;
};
const generateInvoicePdf = async (materials) => {
    const response = await visserApi.post(`Invoice/GenerateInvoicePdf`, materials);
    return response.data;
};
const generateCostEstimatePdfAsAttachment = async (costEstimatePdfData) => {
    const response = await visserApi.post(`Invoice/GenerateCostEstimatePdfAsAttachment`, costEstimatePdfData);
    return response.data;
};
const generateInvoicePdfAsAttachment = async (materials) => {
    const response = await visserApi.post(`Invoice/GenerateInvoicePdfAsAttachment`, materials);
    return response.data;
};
const InvoiceApi = {
    getAllInvoice,
    getAllInvoiceStatus,
    getInvoiceById,
    getWorkOrdersListWithClientAsync,
    getIncrementedInvoiceNumber,
    createInvoice,
    updateInvoice,
    createInvoiceAmount,
    getAllInvoiceAmounts,
    updateInvoiceAmount,
    getInvoiceAmountById,
    deleteInvoiceAmount,
    deleteInvoiceById,
    updateInvoiceAmountPosition,
    updateBulkInvoiceAmount,
    generateCostEstimatePdf,
    generateInvoicePdf,
    generateCostEstimatePdfAsAttachment,
    generateInvoicePdfAsAttachment
};
export default InvoiceApi;
